// import alco from "../../images/icons/bar/alco.png";
import coffee from "../images/icons/bar/coffee.png";
import drinks from "../images/icons/bar/drinks.png";
import lemonade from "../images/icons/bar/lemonade.svg";
import tea from "../images/icons/bar/tea.svg";
import cocktail from "../images/icons/bar/cocktail.svg";
import hard from "../images/icons/bar/hardalko.svg";
import sparkling from "../images/icons/bar/sparkling.svg";
import wine from "../images/icons/bar/wine.svg";

// import breakfast from "../images/icons/kitchen/breakfast.png";
// import dish from "../images/icons/kitchen/dish.png";
// import paste from "../images/icons/kitchen/paste.svg";
// import japan from "../images/icons/kitchen/japan.png";
import mainmenu from "../images/icons/kitchen/mainMenu.svg";
import pizza from "../images/icons/kitchen/pizza.png";
import main from "../images/icons/kitchen/main.svg";
import soup from "../images/icons/kitchen/soup.svg";

export const KITCHEN_ROUTES = [
  {
    title: "Сніданки",
    types: ["Сніданки"],
    route: "/breakfast",
    image: pizza,
  },
  // {
  //   title: "Салати",
  //   types: ["Салати"],
  //   route: "/salad",
  //   image: breakfast,
  // },

  // {
  //   title: "Street food",
  //   types: ["Street food"],
  //   route: "/streetfood",
  //   image: paste,
  // },

  // {
  //   title: "Pizza",
  //   types: ["Піца"],
  //   route: "/pizza",
  //   image: paste,
  // },

  {
    title: "Азійська кухня",
    types: ["Основні Страви"],
    route: "/main-menu",
    image: mainmenu,
  },
  {
    title: "Закуски",
    types: ["Закуски"],
    route: "/appetizer",
    image: main,
  },
  {
    title: "Супи",
    types: ["Перші Страви"],
    route: "/first",
    image: soup,
  },
  // {
  //   title: "Солодощі",
  //   types: ["Солодощі"],
  //   route: "/cakes",
  //   image: dish,
  // },
];

export const DRINK__ROUTES = [
  {
    title: "Кава",
    types: ["Coffee"],
    route: "/coffee",
    image: coffee,
  },

  {
    title: "Альтернатива",
    types: ["Alternative"],
    route: "/alternative",
    image: coffee,
  },
  {
    title: "Чай",
    types: ["Tea"],
    route: "/tea",
    image: tea,
  },
  {
    title: "Лимонади",
    types: ["Lemonades"],
    route: "/lemonades",
    image: lemonade,
  },
  {
    title: "Коктейлі",
    types: ["Cocktails"],
    route: "/cocktails",
    image: cocktail,
  },
  {
    title: "Drinks",
    types: ["Drinks"],
    route: "/drinks",
    image: drinks,
  },

  {
    title: "Покрєпше",
    types: ["Покрєпше"],
    route: "/alco",
    image: hard,
  },
  {
    title: "Sparkling Wine",
    types: ["Sparkling Wine"],
    route: "/sparkling",
    image: sparkling,
  },
  {
    title: "Red Wine",
    types: ["Red Wine"],
    route: "/red-wine",
    image: wine,
  },
  {
    title: "White Wine",
    types: ["White Wine"],
    route: "/white-wine",
    image: wine,
  },
];

export const FILTER_ROUTES = [
  {
    title: "filter",
    types: [
      "Drinks",
      "Салати",
      "Пасти",
      "Сніданки",
      "Alternative",
      "Coffee",
      "Основні Страви",
      "Закуски",
      "Перші Страви",
      "Tea",
      "Lemonades",
      "Cocktails",
      "Покрєпше",
      "Sparkling Wine",
      "Red Wine",
      "White Wine",
      "Солодощі",
    ],
    route: "/filter",
  },
];
